import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts/slice'
import { aggregateServicesByLocationId } from '@user/store/serviceProducts/slice'

export const useGetServicesByLocationId = (locationId: string) => {
  const services = useSelector(selectAllLeadOppProducts)

  const filtered = useMemo(
    () => aggregateServicesByLocationId(locationId, services),
    [locationId, services],
  )

  return filtered
}
